__turbopack_context__.v({
  "active": "r0kwda_active",
  "button": "r0kwda_button",
  "energy-source-tag": "r0kwda_energy-source-tag",
  "image": "r0kwda_image",
  "producer-card": "r0kwda_producer-card",
  "status": "r0kwda_status",
});
